/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconUser8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUser8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                d="M7.354 7.146a.5.5 0 1 1-.708.708C6.084 7.29 5.211 7 4 7c-1.21 0-2.084.291-2.646.854a.5.5 0 1 1-.708-.708C1.417 6.376 2.544 6 4 6c1.456 0 2.583.376 3.354 1.146ZM4 5.4C2.686 5.4 1.75 4.054 1.75 2.485 1.75 1 2.548 0 4 0c1.453 0 2.25 1 2.25 2.485C6.25 4.054 5.315 5.4 4 5.4Zm0-1c.653 0 1.249-.798 1.249-1.915C5.25 1.481 4.83 1 4 1c-.83 0-1.25.48-1.25 1.485C2.75 3.602 3.347 4.4 4 4.4Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconUser12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUser12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M11.03 10.72a.75.75 0 1 1-1.06 1.06C9.126 10.937 7.816 10.5 6 10.5c-1.816 0-3.126.437-3.97 1.28a.75.75 0 0 1-1.06-1.06C2.126 9.563 3.816 9 6 9s3.874.563 5.03 1.72ZM6 8.1c-1.972 0-3.375-2.02-3.375-4.372C2.625 1.5 3.822 0 6.001 0c2.178 0 3.374 1.5 3.374 3.728C9.375 6.08 7.973 8.1 6.001 8.1Zm0-1.5c.98 0 1.875-1.197 1.875-2.872 0-1.507-.63-2.228-1.874-2.228-1.245 0-1.876.721-1.876 2.228 0 1.675.895 2.872 1.876 2.872Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconUser16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUser16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M14.707 14.293a1 1 0 0 1-1.414 1.414C12.168 14.582 10.422 14 8 14s-4.168.582-5.293 1.707a1 1 0 0 1-1.414-1.414C2.834 12.75 5.088 12 8 12s5.165.751 6.707 2.293ZM8.001 10.8C5.371 10.8 3.5 8.108 3.5 4.97 3.5 2 5.096 0 8.001 0 10.906 0 12.5 2 12.5 4.97c0 3.138-1.87 5.83-4.499 5.83Zm0-2c1.307 0 2.499-1.596 2.499-3.83C10.5 2.961 9.66 2 8.001 2 6.341 2 5.5 2.962 5.5 4.97c0 2.233 1.194 3.83 2.501 3.83Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconUser20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUser20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M10 12.35c-3.25 0-5-3.175-5-6.725C5 2.15 7 0 10 0c2.999 0 4.999 2.15 4.999 5.625 0 3.55-1.75 6.725-5 6.725Zm0-2c1.738 0 2.999-1.849 2.999-4.725 0-2.379-1.122-3.625-3-3.625S7 3.246 7 5.625c0 2.876 1.26 4.725 3 4.725Zm-7.06 9.648a1 1 0 0 0 1.058-.938C4.113 17.138 6.041 16 10.003 16c3.96 0 5.882 1.136 5.999 3.06a1 1 0 0 0 1.996-.12C17.803 15.721 14.89 14 10.003 14c-4.888 0-7.808 1.723-8.001 4.94a1 1 0 0 0 .938 1.058Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconUser24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUser24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M12 14.35c-3.25 0-5-3.175-5-6.725C7 4.15 9 2 12 2c2.999 0 4.999 2.15 4.999 5.625 0 3.55-1.75 6.725-5 6.725Zm0-2c1.738 0 2.999-1.849 2.999-4.725 0-2.379-1.122-3.625-3-3.625S9 5.246 9 7.625c0 2.876 1.26 4.725 3 4.725Zm-7.06 9.648a1 1 0 0 0 1.058-.938C6.113 19.138 8.041 18 12.003 18c3.96 0 5.882 1.136 5.999 3.06a1 1 0 1 0 1.996-.12C19.803 17.721 16.89 16 12.003 16c-4.888 0-7.808 1.723-8.001 4.94a1 1 0 0 0 .938 1.058Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconUser = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconUser(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconUser8 {...iconProps} />;
        case '12':
            return <IconUser12 {...iconProps} />;
        case '16':
            return <IconUser16 {...iconProps} />;
        case '20':
            return <IconUser20 {...iconProps} />;
        case '24':
            return <IconUser24 {...iconProps} />;
        default:
            return <IconUser24 {...iconProps} />;
    }
});
